import { styled } from "common/components";

export const StyledMessageContainer = styled("div")(({ theme }) => ({
  display: "grid",
  rowGap: theme.spacing(0.4),
  padding: theme.spacing(0.5, 0, 3, 0),
}));
